var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _path14, _path15, _path16, _path17, _circle3, _path18, _circle4, _circle5, _circle6, _path19, _circle7, _circle8, _path20, _path21, _circle9, _circle10, _path22, _path23, _circle11, _circle12, _circle13, _path24, _circle14, _path25, _circle15, _path26, _circle16, _circle17, _circle18, _path27, _path28, _path29, _circle19, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHorseShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.283,
    x2: 491.717,
    xlinkHref: "#lg1",
    y1: 257.923,
    y2: 257.923
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.659,
    x2: 524.844,
    xlinkHref: "#lg1",
    y1: 65.549,
    y2: 525.733
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 757.262,
    x2: -319.033,
    xlinkHref: "#lg1",
    y1: 572.999,
    y2: -117.493
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.584,
    x2: 125.522,
    xlinkHref: "#lg2",
    y1: 141.099,
    y2: 42.272
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.784,
    x2: 328.844,
    xlinkHref: "#lg2",
    y1: 196.27,
    y2: -12.814
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.107,
    x2: 123.62,
    xlinkHref: "#lg1",
    y1: 22.704,
    y2: 108.244
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.747,
    x2: 79.365,
    xlinkHref: "#lg3",
    y1: 60.824,
    y2: -5.825
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.727,
    x2: 270.247,
    xlinkHref: "#lg2",
    y1: 51.523,
    y2: 199.867
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.081,
    x2: 429.595,
    xlinkHref: "#lg1",
    y1: 22.704,
    y2: 108.244
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.721,
    x2: 385.339,
    xlinkHref: "#lg3",
    y1: 60.824,
    y2: -5.825
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.701,
    x2: 576.222,
    xlinkHref: "#lg2",
    y1: 51.523,
    y2: 199.867
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.091,
    x2: 202.608,
    xlinkHref: "#lg2",
    y1: 90.179,
    y2: 333.11
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.183,
    x2: 381.917,
    xlinkHref: "#lg2",
    y1: 405.525,
    y2: 659.809
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-1 .026 -.026 -1 -398.529 499.453)",
    gradientUnits: "userSpaceOnUse",
    x1: -663.989,
    x2: -631.805,
    xlinkHref: "#lg4",
    y1: 27.417,
    y2: 59.601
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1472.099,
    x2: 1497.944,
    xlinkHref: "#lg4",
    y1: 242.629,
    y2: 268.474
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1481.959,
    x2: 1469.647,
    xlinkHref: "#lg5",
    y1: 253.489,
    y2: 236.034
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1480.258,
    x2: 1507.687,
    xlinkHref: "#lg6",
    y1: 257.743,
    y2: 206.728
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(-1 .026 -.026 -1 -398.529 499.453)",
    gradientUnits: "userSpaceOnUse",
    x1: -565.934,
    x2: -533.75,
    xlinkHref: "#lg4",
    y1: 56.641,
    y2: 88.825
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1374.044,
    x2: 1399.889,
    xlinkHref: "#lg4",
    y1: 213.404,
    y2: 239.25
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1383.905,
    x2: 1371.592,
    xlinkHref: "#lg5",
    y1: 224.265,
    y2: 206.81
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1382.203,
    x2: 1409.633,
    xlinkHref: "#lg6",
    y1: 228.519,
    y2: 177.504
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(-1 .026 -.026 -1 -398.529 499.453)",
    gradientUnits: "userSpaceOnUse",
    x1: -763.444,
    x2: -731.26,
    xlinkHref: "#lg4",
    y1: 51.445,
    y2: 83.629
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1571.554,
    x2: 1597.399,
    xlinkHref: "#lg4",
    y1: 218.601,
    y2: 244.446
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1581.415,
    x2: 1569.102,
    xlinkHref: "#lg5",
    y1: 229.461,
    y2: 212.006
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1579.714,
    x2: 1607.143,
    xlinkHref: "#lg6",
    y1: 233.715,
    y2: 182.7
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(-1 .026 -.026 -1 -398.529 499.453)",
    gradientUnits: "userSpaceOnUse",
    x1: -507.364,
    x2: -475.18,
    xlinkHref: "#lg4",
    y1: 126.778,
    y2: 158.962
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1315.474,
    x2: 1341.319,
    xlinkHref: "#lg4",
    y1: 143.268,
    y2: 169.113
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1325.335,
    x2: 1313.022,
    xlinkHref: "#lg5",
    y1: 154.128,
    y2: 136.673
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1323.633,
    x2: 1351.063,
    xlinkHref: "#lg6",
    y1: 158.382,
    y2: 107.367
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-1 .026 -.026 -1 -398.529 499.453)",
    gradientUnits: "userSpaceOnUse",
    x1: -825.621,
    x2: -793.437,
    xlinkHref: "#lg4",
    y1: 118.405,
    y2: 150.589
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1633.731,
    x2: 1659.576,
    xlinkHref: "#lg4",
    y1: 151.64,
    y2: 177.485
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1643.592,
    x2: 1631.279,
    xlinkHref: "#lg5",
    y1: 162.501,
    y2: 145.045
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1641.89,
    x2: 1669.32,
    xlinkHref: "#lg6",
    y1: 166.754,
    y2: 115.74
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientTransform: "matrix(-1 .026 -.026 -1 -398.529 499.453)",
    gradientUnits: "userSpaceOnUse",
    x1: -485.237,
    x2: -453.053,
    xlinkHref: "#lg4",
    y1: 222.601,
    y2: 254.785
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1293.347,
    x2: 1319.192,
    xlinkHref: "#lg4",
    y1: 47.445,
    y2: 73.29
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1303.208,
    x2: 1290.895,
    xlinkHref: "#lg5",
    y1: 58.305,
    y2: 40.85
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1301.507,
    x2: 1328.936,
    xlinkHref: "#lg6",
    y1: 62.559,
    y2: 11.544
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientTransform: "matrix(-1 .026 -.026 -1 -398.529 499.453)",
    gradientUnits: "userSpaceOnUse",
    x1: -852.756,
    x2: -820.572,
    xlinkHref: "#lg4",
    y1: 212.932,
    y2: 245.116
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1660.866,
    x2: 1686.711,
    xlinkHref: "#lg4",
    y1: 57.113,
    y2: 82.958
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1670.726,
    x2: 1658.414,
    xlinkHref: "#lg5",
    y1: 67.974,
    y2: 50.518
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1669.025,
    x2: 1696.454,
    xlinkHref: "#lg6",
    y1: 72.228,
    y2: 21.213
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientTransform: "matrix(-1 .026 -.026 -1 -398.529 499.453)",
    gradientUnits: "userSpaceOnUse",
    x1: -504.003,
    x2: -471.819,
    xlinkHref: "#lg4",
    y1: 319.531,
    y2: 351.715
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1312.113,
    x2: 1337.958,
    xlinkHref: "#lg4",
    y1: -49.486,
    y2: -23.641
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1321.973,
    x2: 1309.661,
    xlinkHref: "#lg5",
    y1: -38.626,
    y2: -56.081
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1320.272,
    x2: 1347.701,
    xlinkHref: "#lg6",
    y1: -34.372,
    y2: -85.387
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientTransform: "matrix(-1 .026 -.026 -1 -398.529 499.453)",
    gradientUnits: "userSpaceOnUse",
    x1: -839.113,
    x2: -806.929,
    xlinkHref: "#lg4",
    y1: 310.716,
    y2: 342.899
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1647.222,
    x2: 1673.068,
    xlinkHref: "#lg4",
    y1: -40.67,
    y2: -14.825
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1657.083,
    x2: 1644.771,
    xlinkHref: "#lg5",
    y1: -29.81,
    y2: -47.265
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientTransform: "matrix(1 -.026 .026 1 -1230.699 234.424)",
    gradientUnits: "userSpaceOnUse",
    x1: 1655.382,
    x2: 1682.811,
    xlinkHref: "#lg6",
    y1: -25.556,
    y2: -76.571
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m331.312 17.635c0 44.481 10.467 88.307 30.353 128.095 15.505 31.023 24.423 66.592 24.423 99.033 0 81.205-58.69 147.035-131.088 147.035s-131.088-65.83-131.088-147.035c0-32.441 8.918-68.01 24.423-99.033 19.886-39.788 30.353-83.614 30.353-128.095 0-9.145-9.992-14.811-17.822-10.087-85.764 51.738-142.583 167.626-142.583 265.735 0 130.735 105.982 236.717 236.717 236.717s236.717-105.982 236.717-236.717c0-98.109-56.819-213.997-142.583-265.735-7.83-4.724-17.822.943-17.822 10.087z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m331.312 17.635c0 44.481 10.467 88.307 30.353 128.095 15.505 31.023 24.423 66.592 24.423 99.033 0 81.205-58.69 147.035-131.088 147.035s-131.088-65.83-131.088-147.035c0-32.441 8.918-68.01 24.423-99.033 19.886-39.788 30.353-83.614 30.353-128.095 0-9.145-9.992-14.811-17.822-10.087-85.764 51.738-142.583 167.626-142.583 265.735 0 130.735 105.982 236.717 236.717 236.717s236.717-105.982 236.717-236.717c0-98.109-56.819-213.997-142.583-265.735-7.83-4.724-17.822.943-17.822 10.087z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m255 493.386c-121.366 0-220.104-98.738-220.104-220.104 0-45.972 13.226-96.602 37.241-142.563 23.081-44.174 54.735-80.83 89.785-104.172-1.309 38.544-11.077 76.997-28.449 111.754-16.88 33.775-26.176 71.584-26.176 106.461 0 90.236 66.259 163.649 147.702 163.649s147.702-73.413 147.702-163.649c0-34.877-9.296-72.686-26.176-106.459-17.372-34.758-27.14-73.212-28.449-111.755 35.049 23.34 66.704 59.998 89.785 104.172 24.016 45.961 37.241 96.591 37.241 142.563.002 121.365-98.736 220.103-220.102 220.103z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m145.012 152.701c1.075-2.344 2.175-4.673 3.324-6.97 19.886-39.788 30.353-83.614 30.353-128.095 0-9.144-9.992-14.811-17.822-10.087-31.633 19.083-59.322 46.9-81.681 79.326z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m349.134 7.548c-7.83-4.724-17.822.943-17.822 10.087 0 23.431 2.933 46.674 8.589 69.247l149.247 149.248c-11.966-88.704-64.882-183.259-140.014-228.582z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m165.127 86.843h-126.228c-14.297 0-25.887-11.59-25.887-25.887v-35.07c0-14.296 11.59-25.886 25.887-25.886h126.228c14.297 0 25.887 11.59 25.887 25.887v35.07c0 14.297-11.59 25.886-25.887 25.886z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m51.32 10.229c-14.297 0-25.887 11.59-25.887 25.887v35.069c0 5.107 1.499 9.855 4.052 13.866 2.921 1.142 6.089 1.792 9.414 1.792h126.228c14.297 0 25.887-11.59 25.887-25.887v-35.07c0-5.107-1.499-9.854-4.052-13.866-2.921-1.142-6.089-1.792-9.414-1.792h-126.228z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m165.127 0h-2.398c2.815 4.143 4.463 9.144 4.463 14.53v35.07c0 14.297-11.59 25.887-25.887 25.887h-123.83c4.657 6.853 12.513 11.356 21.424 11.356h126.228c14.297 0 25.887-11.59 25.887-25.887v-35.07c0-14.296-11.59-25.886-25.887-25.886z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m471.101 86.843h-126.228c-14.297 0-25.887-11.59-25.887-25.887v-35.07c0-14.296 11.59-25.886 25.887-25.886h126.228c14.297 0 25.887 11.59 25.887 25.887v35.07c0 14.297-11.59 25.886-25.887 25.886z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m357.294 10.229c-14.297 0-25.887 11.59-25.887 25.887v35.069c0 5.107 1.499 9.855 4.052 13.866 2.921 1.142 6.089 1.792 9.414 1.792h126.228c14.297 0 25.887-11.59 25.887-25.887v-35.07c0-5.107-1.499-9.854-4.052-13.866-2.921-1.142-6.089-1.792-9.414-1.792h-126.228z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m471.101 0h-2.398c2.815 4.143 4.463 9.144 4.463 14.53v35.07c0 14.297-11.59 25.887-25.887 25.887h-123.829c4.657 6.853 12.513 11.356 21.423 11.356h126.228c14.297 0 25.887-11.59 25.887-25.887v-35.07c0-14.296-11.59-25.886-25.887-25.886z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m129.031 113.389c-15.505 31.022-24.423 66.592-24.423 99.033 0 37.245 12.352 71.249 32.704 97.157-8.576-19.554-13.4-41.551-13.4-64.815 0-32.441 8.918-68.01 24.423-99.033 19.886-39.788 30.353-83.614 30.353-128.095 0-9.144-9.992-14.811-17.822-10.087-.836.505-1.665 1.026-2.495 1.543-3.049 36.238-13.012 71.629-29.34 104.297z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m432.82 89.813c25.209 47.923 39.593 101.773 39.593 151.128 0 130.735-105.982 236.717-236.717 236.717-79.668 0-150.144-39.356-193.046-99.687 38.637 78.221 119.204 132.029 212.35 132.029 130.735 0 236.717-105.982 236.717-236.717 0-60.833-21.851-128.497-58.897-183.47z",
    fill: "url(#SVGID_13_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 445.531,
    fill: "url(#SVGID_14_)",
    r: 24.851
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 445.531,
    fill: "url(#SVGID_15_)",
    r: 19.956
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m271.649 445.093c.242 9.195-7.016 16.845-16.211 17.087s-16.845-7.016-17.087-16.211 7.016-16.845 16.211-17.087 16.845 7.016 17.087 16.211z",
    fill: "url(#SVGID_16_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m263.454 427.451c1.416 2.65 2.254 5.66 2.339 8.868.29 11.018-8.406 20.184-19.424 20.474-3.208.084-6.258-.594-8.979-1.869 3.447 6.451 10.326 10.761 18.135 10.556 11.018-.29 19.714-9.456 19.424-20.474-.205-7.809-4.872-14.451-11.495-17.555z",
    fill: "url(#SVGID_17_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m131.364 419.548c-.361-13.72 10.468-25.134 24.188-25.495s25.135 10.468 25.496 24.188-10.468 25.135-24.188 25.496-25.135-10.469-25.496-24.189z",
    fill: "url(#SVGID_18_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m176.155 418.37c.29 11.017-8.407 20.184-19.424 20.474-11.018.29-20.184-8.406-20.474-19.424s8.407-20.184 19.424-20.474c11.018-.291 20.184 8.406 20.474 19.424z",
    fill: "url(#SVGID_19_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.206,
    cy: 418.895,
    fill: "url(#SVGID_20_)",
    r: 16.655
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m164.66 400.815c1.416 2.65 2.254 5.66 2.339 8.868.29 11.018-8.407 20.184-19.424 20.474-3.208.084-6.258-.594-8.979-1.869 3.448 6.451 10.326 10.761 18.135 10.556 11.018-.29 19.714-9.457 19.424-20.474-.205-7.81-4.871-14.452-11.495-17.555z",
    fill: "url(#SVGID_21_)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.794,
    cy: 418.895,
    fill: "url(#SVGID_22_)",
    r: 24.85
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.794,
    cy: 418.895,
    fill: "url(#SVGID_23_)",
    r: 19.956
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.794,
    cy: 418.895,
    fill: "url(#SVGID_24_)",
    r: 16.655
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m362.248 400.815c1.416 2.65 2.254 5.66 2.339 8.868.29 11.018-8.407 20.184-19.424 20.474-3.208.084-6.259-.594-8.979-1.869 3.448 6.451 10.326 10.761 18.135 10.556 11.018-.29 19.714-9.457 19.424-20.474-.206-7.81-4.872-14.452-11.495-17.555z",
    fill: "url(#SVGID_25_)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.809,
    cy: 350.319,
    fill: "url(#SVGID_26_)",
    r: 24.851
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.809,
    cy: 350.319,
    fill: "url(#SVGID_27_)",
    r: 19.956
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m112.458 349.881c.242 9.195-7.016 16.845-16.211 17.087s-16.845-7.016-17.087-16.211 7.016-16.845 16.211-17.087 16.845 7.016 17.087 16.211z",
    fill: "url(#SVGID_28_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m104.263 332.239c1.416 2.65 2.254 5.66 2.339 8.868.29 11.018-8.406 20.184-19.424 20.474-3.208.084-6.258-.594-8.979-1.869 3.448 6.451 10.326 10.761 18.135 10.556 11.018-.29 19.714-9.456 19.424-20.474-.205-7.809-4.872-14.452-11.495-17.555z",
    fill: "url(#SVGID_29_)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.191,
    cy: 350.319,
    fill: "url(#SVGID_30_)",
    r: 24.851
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 414.191,
    cy: 350.319,
    fill: "url(#SVGID_31_)",
    r: 19.956
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m430.84 349.881c.242 9.195-7.016 16.845-16.211 17.087s-16.845-7.016-17.087-16.211 7.016-16.845 16.211-17.087 16.845 7.016 17.087 16.211z",
    fill: "url(#SVGID_32_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m422.645 332.239c1.416 2.65 2.254 5.66 2.339 8.868.29 11.018-8.406 20.184-19.424 20.474-3.208.084-6.258-.594-8.979-1.869 3.447 6.451 10.326 10.761 18.135 10.556 11.017-.29 19.714-9.456 19.424-20.474-.205-7.809-4.872-14.452-11.495-17.555z",
    fill: "url(#SVGID_33_)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.169,
    cy: 255.107,
    fill: "url(#SVGID_34_)",
    r: 24.85
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.169,
    cy: 255.107,
    fill: "url(#SVGID_35_)",
    r: 19.956
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.169,
    cy: 255.107,
    fill: "url(#SVGID_36_)",
    r: 16.655
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m79.623 237.027c1.416 2.65 2.254 5.66 2.339 8.868.29 11.018-8.407 20.184-19.424 20.474-3.208.084-6.259-.594-8.979-1.869 3.448 6.451 10.326 10.761 18.135 10.556 11.018-.29 19.714-9.457 19.424-20.474-.206-7.81-4.872-14.452-11.495-17.555z",
    fill: "url(#SVGID_37_)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.831,
    cy: 255.107,
    fill: "url(#SVGID_38_)",
    r: 24.85
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m458.78 254.582c.29 11.017-8.407 20.184-19.424 20.474-11.018.29-20.184-8.406-20.474-19.424s8.407-20.184 19.424-20.474c11.018-.29 20.184 8.406 20.474 19.424z",
    fill: "url(#SVGID_39_)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 438.831,
    cy: 255.107,
    fill: "url(#SVGID_40_)",
    r: 16.655
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m447.285 237.027c1.416 2.65 2.254 5.66 2.339 8.868.29 11.018-8.407 20.184-19.424 20.474-3.208.084-6.259-.594-8.979-1.869 3.447 6.451 10.326 10.761 18.135 10.556 11.018-.29 19.714-9.457 19.424-20.474-.205-7.81-4.871-14.452-11.495-17.555z",
    fill: "url(#SVGID_41_)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.379,
    cy: 157.712,
    fill: "url(#SVGID_42_)",
    r: 24.85
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.38,
    cy: 157.712,
    fill: "url(#SVGID_43_)",
    r: 19.956
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.379,
    cy: 157.712,
    fill: "url(#SVGID_44_)",
    r: 16.655
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m95.834 139.632c1.416 2.65 2.254 5.66 2.339 8.868.29 11.017-8.407 20.184-19.424 20.474-3.208.084-6.258-.594-8.979-1.869 3.448 6.451 10.326 10.761 18.135 10.556 11.018-.29 19.714-9.456 19.424-20.474-.206-7.81-4.872-14.452-11.495-17.555z",
    fill: "url(#SVGID_45_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m397.779 158.365c-.361-13.72 10.468-25.134 24.188-25.495s25.135 10.468 25.496 24.188-10.468 25.135-24.188 25.496c-13.721.361-25.135-10.469-25.496-24.189z",
    fill: "url(#SVGID_46_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m442.569 157.187c.29 11.018-8.406 20.184-19.424 20.474s-20.184-8.407-20.474-19.424c-.29-11.018 8.407-20.184 19.424-20.474 11.018-.29 20.185 8.406 20.474 19.424z",
    fill: "url(#SVGID_47_)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 422.62,
    cy: 157.712,
    fill: "url(#SVGID_48_)",
    r: 16.655
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m431.075 139.632c1.416 2.65 2.254 5.66 2.339 8.868.29 11.017-8.406 20.184-19.424 20.474-3.208.084-6.258-.594-8.979-1.869 3.447 6.451 10.326 10.761 18.135 10.556 11.018-.29 19.714-9.456 19.424-20.474-.206-7.81-4.872-14.452-11.495-17.555z",
    fill: "url(#SVGID_49_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHorseShow);
export default __webpack_public_path__ + "static/media/icon-horse-show.6a754723262ae75adc8443f1a39c0514.svg";
export { ForwardRef as ReactComponent };